import { render, staticRenderFns } from "./MyProjectStatusLayer.vue?vue&type=template&id=280c7341&scoped=true"
import script from "./MyProjectStatusLayer.vue?vue&type=script&setup=true&lang=ts"
export * from "./MyProjectStatusLayer.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./MyProjectStatusLayer.vue?vue&type=style&index=0&id=280c7341&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280c7341",
  null
  
)

export default component.exports